<template>
    <div class="cs-defaultHeader__container" >
    <div class="cs-defaultHeader">
          <div class="cs-defaultHeader__offerQuantity">{{formatQuantityToLocale(offer.serviceQuantity)}}</div>
          <div class="cs-defaultHeader__close"> <img v-on:click="$emit('closeComponent')" src="https://comprasocial.me/wp-content/uploads/2022/11/close-red.svg" > </div>
        </div>
        <div class="cs-defaultHeader__serviceName" :class="{'cs-scrollingText': isTextLongerThan(offer.serviceName,25), 'cs-defaultHeader__serviceName--scrolling': isTextLongerThan(offer.serviceName,25) }">{{offer.serviceName}}</div>
    </div>
</template>

<script>
    import {formatQuantityToLocale, isTextLongerThan} from "@/assets/js/formatUtils";
    export default{
        name: 'DefaultHeader',
        props: [
            "offer"
        ],
        emits: [
            "closeComponent"
        ],
        methods: {
            formatQuantityToLocale : formatQuantityToLocale,
            isTextLongerThan: isTextLongerThan
        },
    }
</script>

<style lang="scss" scoped>
@import "@/assets/scss/animations.scss";
    .cs-defaultHeader{
        display: grid;
        grid-template-columns: 1fr 1fr;

        &__offerQuantity {
            grid-column: 1 / span 2;
            grid-row: 1;
            color: #7762EF;
            font-size: 22px;
            font-weight: 700;
        }

        &__close {
            grid-column: 2;
            grid-row: 1;
            justify-self: end;
            cursor: pointer;
        }

        &__serviceName {
            color: #7762EF;
            font-size: 22px;
            font-weight: 700;
            white-space: nowrap;

            &--scrolling{
                margin-left: 20px;
                width: fit-content;
            }
        }
    }

</style>